import { render, staticRenderFns } from "./FrotaFilterBar.vue?vue&type=template&id=f06f7e74"
import script from "./FrotaFilterBar.vue?vue&type=script&lang=js"
export * from "./FrotaFilterBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports